/**
 * SettingsGroup - группа настроек с заголовком
 */
import React from 'react';

export default function SettingsGroup({
  title,
  children,
  rightAction, // React элемент для кнопки справа
}) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-sm text-text-secondary uppercase tracking-wider">
          {title}
        </h3>
        {rightAction}
      </div>
      {children}
    </div>
  );
}
